"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlIconValidation = void 0;

var _react = require("react");

var _glIcon = require("./gl-icon");

var _jsxRuntime = require("react/jsx-runtime");

var GlIconValidationCore = function GlIconValidationCore(_ref) {
  var className = _ref.className,
      iconClassName = _ref.iconClassName,
      success = _ref.success,
      title = _ref.title;
  var name = success ? 'checkbox-checkmark' : 'cross-small';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_glIcon.GlIcon, {
    name: name,
    title: title,
    className: className,
    iconClassName: iconClassName
  });
};

var GlIconValidation = /*#__PURE__*/(0, _react.memo)(GlIconValidationCore);
exports.GlIconValidation = GlIconValidation;